import { ZfBox } from '@zafire/react';
import type { FunctionComponent, PropsWithChildren } from 'react';
import {
    CLIENT_INFO_HEIGHT,
    getClientBarHeight,
    getMaxTileHeight,
    getMaxTileWidth,
    getNumberOfRowGaps,
    GRID_COLUMNS,
    GRID_GAP,
    PADDING_X,
    PADDING_Y,
    TITLE_HEIGHT,
} from '../../utils/topicUtils';

interface IProps extends PropsWithChildren {
    height: number;
    width: number;
    isPresentationMode: boolean;
    wnInfoBannerHeight?: number;
}

export const TopicGrid: FunctionComponent<IProps> = ({ height, width, isPresentationMode, wnInfoBannerHeight = 0, children }) => {
    const clientBarHeight = getClientBarHeight(isPresentationMode);
    const numberOfRowGaps = getNumberOfRowGaps(isPresentationMode);

    // (containerWidth - columnGapsWidth - containerPadding) / <number of columns>
    const maxTileWidth = getMaxTileWidth(width);

    // (containerHeight - rowGapsHeight - containerPadding - clientBarHeight) / <number of rows of tiles>
    const maxTileHeight = getMaxTileHeight(height, numberOfRowGaps, clientBarHeight + wnInfoBannerHeight);

    return (
        <ZfBox
            style={{
                display: 'grid',
                gap: `${GRID_GAP}px`,
                padding: `${PADDING_Y}px ${PADDING_X}px`,
                gridTemplateColumns: `repeat(${GRID_COLUMNS}, ${maxTileWidth}px)`,
                gridTemplateRows: `${isPresentationMode ? `minMax(auto, ${TITLE_HEIGHT}px)` : ''} minMax(auto, ${CLIENT_INFO_HEIGHT}px) repeat(2, ${maxTileHeight}px)`,
            }}
        >
            {children}
        </ZfBox>
    );
};
